/* eslint-disable no-unused-vars */
import { memo } from 'react';
import { Stack, Typography } from '@mui/material';
import { ToggleBtn, ConversionTracking, Loader } from 'components';
import { Palette } from 'config';
import { useFacade } from './useFacade';
import { Accordion, AccordionDetails } from '@mui/material';
import styled from 'styled-components';

const ConversionTrackingSection = ({ environment }) => {
  const {
    selectedCreative,
    selectedTracking,
    handleChange,
    linkUpdateAction,
    isCustomTracking,
    update_one_tc_number,
    isHiddenFlag,
  } = useFacade(environment);

  if (selectedCreative) {
    if (!Object.entries(selectedCreative)?.length) {
      return <Loader.Local delay={1} />;
    }
  }

  return (
    <Container>
      <Accordion expanded={isCustomTracking} TransitionProps={{ unmountOnExit: true }}>
        <Stack sx={{ marginTop: '2px' }}>
          <Stack
            direction='row'
            justifyContent='flex-start'
            alignItems='center'
            sx={{ marginTop: '34px', gap: '8px' }}
          >
            <Typography style={TitleLabels}>Custom Tracking for Creative:</Typography>
            <ToggleBtn
              isChecked={isCustomTracking}
              onChange={handleChange}
              id='isCustomTracking'
              lableOn=''
              labelOff=''
            />
          </Stack>
          {/* <Typography style={TextStyle}>
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
            has been the industry&apos;s standard dummy text ever since the 1500s
          </Typography> */}
        </Stack>
        <AccordionDetails>
          <ConversionTracking.EditCampaign
            {...selectedTracking}
            linkUpdateAction={linkUpdateAction}
            update_tc_number={update_one_tc_number}
          />
        </AccordionDetails>
      </Accordion>
    </Container>
  );
};

export default memo(ConversionTrackingSection);

const Container = styled.div`
  .MuiAccordion-root {
    box-shadow: none;
  }
  .MuiAccordionDetails-root {
    padding: 0;
  }
`;

const TitleLabels = {
  color: `${Palette.PrimaryGray._700}`,
  height: '20px',
  fontFamily: 'Roboto',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
};

const TextStyle = {
  color: `${Palette.PrimaryGray._700}`,
  fontFamily: 'Roboto',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '16px',
  width: '365px',
  marginTop: '8px',
  marginBottom: '32px',
};
